import React from "react";
import { Brain } from "lucide-react";

const AIFeedbackSection = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <div className="inline-flex p-3 rounded-xl bg-primary/10 mb-6">
          <Brain className="w-8 h-8 text-primary" />
        </div>
        <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6">
          Instant AI Feedback
        </h2>
        <p className="text-lg text-muted-foreground leading-relaxed">
          Receive real-time analysis from our AI agent trained on the CIA's declassified 
          Remote Viewing protocols. Get immediate insights on your impressions, identify 
          patterns in your sessions, and refine your technique with guidance rooted in 
          decades of scientific research.
        </p>
      </div>
    </section>
  );
};

export default AIFeedbackSection;
